<template>
  <div
  :class="customer ? 'position-relative pt-2 text-left' : 'w-100 position-relative pt-2 text-left'">
    <b-row
      v-for="(status, idx) in statuses"
      :key="status"
      class="d-flex align-items-center"
      :class="{
        'text-info': complete(idx),
        'text-muted': !complete(idx),
      }"
      style="z-index: 4;"
    >
      <b-col cols="auto" style="z-index: 10;">
        <div
          :class="{
            'bg-secondary': !complete(idx),
            'bg-primary': complete(idx),
          }"
          style="width: 0.5em; height: 0.5em; border-radius: 50%;"
        ></div>
      </b-col>
      <b-col cols="auto"
      :class="{
            'text-gray': !complete(idx),
            'text-dark': complete(idx),
          }"
      style="font-size: smaller;">
        {{ status | capitalize() }}
        <span
        v-if="container.name !== '' &&
        (status === 'Shipping to' || status === 'Arrived in')"
        >
        {{getPort(status)}}
      </span>
      <span
        v-if="(status === 'Shipment')"
        >
        {{getPickupType()}}
      </span>
      <span
        v-if="(status === 'Ready for Delivery')"
        >
        {{getDeliveryType()}}
      </span>
      </b-col>
      <b-col col class="text-right" style="font-size: smaller;">
        <b-icon
          :icon="complete(idx) ? 'clock-fill' : 'clock'"
          :class="{
            'text-muted': !complete(idx),
            'text-dark': complete(idx),
          }"
        ></b-icon>
         <!-- v-b-tooltip.hover.left
          title="2020-07-30 15:00:00" -->
      </b-col>
    </b-row>
    <div
      class="position-absolute"
      style="bottom: 11px; left: 4px; width: 1px; height: calc(100% - 30px); background: #c9c9c9;"
    >
      <div
        class="position-absolute bg-primary"
        style="top: 0; width: 1px;"
        :style="{ height: `${progress}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipmentStatusProgress',
  props: {
    currentStatus: {
      type: String,
    },
    container: {
      type: Object,
    },
    shipmentData: {
      type: Object,
    },
    customer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusesTypes: [
        { value: 'booked', text: 'Booking Created' },
        { value: 'pickup', text: 'Shipment' },
        { value: 'toload', text: 'Shipping to' },
        { value: 'tooffload', text: 'Arrived in' },
        { value: 'todeliver', text: 'Ready for Delivery' },
        { value: 'completed', text: 'Delivered' },
      ],
      statuses: [
        'Booking Created',
        'Shipment',
        'Shipment Received by Carrier',
        'Shipping to',
        'Arrived in',
        'Ready for Delivery',
        'Delivered',
      ],
      deliveryTypes: [
        { value: null, text: 'Delivery Type' },
        { value: 'portToPort', text: 'Port To Port' },
        { value: 'preClearance', text: 'Pre-Clearance' },
        { value: 'doorToDoor', text: 'Door To Door' },
        { value: 'doorToWarehouse', text: 'Door To Warehouse' },
        { value: 'doorToPort', text: 'Door To Port' },
      ],
    };
  },
  computed: {
    progress() {
      return (this.completeIdx / (this.statuses.length - 1)) * 100;
    },
    completeIdx() {
      if (!this.currentStatus) {
        return -1;
      }
      let i = -1;
      // for (i = 0; i < this.statuses.length; i += 1) {
      //   if (this.statusesTypes[i].value === this.currentStatus) {
      //     break;
      //   }
      // }
      // return i === this.statuses.length ? 0 : i;
      for (i = 0; i < this.statusesTypes.length; i += 1) {
        if (this.statusesTypes[i].value === this.currentStatus) {
          break;
        }
      }
      if (this.currentStatus === 'toload' && this.container.loadingPort === undefined) {
        return this.statuses.findIndex(
          (status) => status === 'Shipment Received by Carrier',
        );
      }
      return i === this.statuses.length ? 0 : this.statuses.findIndex(
        (status) => status === this.statusesTypes[i].text,
      );
    },
  },
  methods: {
    complete(idx) {
      return idx <= this.completeIdx;
    },
    getPort(status) {
      if (status === 'Shipping to') {
        if (this.container.destination !== undefined && this.container.destination !== '') {
          return `--- ${this.container.destination}`.toUpperCase();
        }
      }

      if (status === 'Arrived in') {
        let string = '';
        if (this.container.destination !== undefined && this.container.destination !== '') {
          string = string.concat(`--- ${this.container.destination}`);
        }
        if (this.container.unloadingPort !== undefined && this.container.unloadingPort !== '') {
          string = string.concat(` (Port ${this.container.unloadingPort})`);
        }
        return string.toUpperCase();
      }
      return '';
    },
    getPickupType() {
      if (this.shipmentData.pickupDetails.pickupMode !== undefined && this.shipmentData.pickupDetails.pickupMode !== '') {
        const capitalize = this.shipmentData.pickupDetails.pickupMode[0].toUpperCase()
        + this.shipmentData.pickupDetails.pickupMode.slice(1);
        return `${capitalize}`;
      }

      return '';
    },
    getDeliveryType() {
      if (this.shipmentData.itemDetails.shippingTerm !== undefined && this.shipmentData.itemDetails.shippingTerm !== '') {
        const deliverytype = this.deliveryTypes.find(
          (type) => type.value === this.shipmentData.itemDetails.shippingTerm,
        ).text;
        return `(${deliverytype})`.toUpperCase();
      }

      return '';
    },
  },
  filters: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style scoped>
.bg-active {
  background: var(--hover-color);
}

.bg-idle {
  background: var(--accent-color);
}
</style>
